import React from "react";
import { useLang } from "../../context/LanguageContext";

const Services = ({ services }) => {
  const { lang, t } = useLang();

  if (!services?.length) return null;

  return (
    <section id="services" data-testid="services-section" className="py-24 sm:py-32 bg-[#0A0A0C]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-6 md:gap-10 mb-16">
          <div className="md:col-span-5">
            <div className="text-xs tracking-[0.4em] uppercase text-[#D4AF37] mb-6">
              {t("services.overline")}
            </div>
            <h2 className="font-display font-light text-4xl sm:text-5xl md:text-6xl tracking-tighter text-white leading-[1]">
              {t("services.title")}
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-base md:text-lg text-white/60 leading-relaxed">
              {t("services.subtitle")}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
          {services.map((svc, idx) => {
            const spans = [
              "md:col-span-7 md:row-span-2",
              "md:col-span-5",
              "md:col-span-5",
              "md:col-span-4",
              "md:col-span-8",
            ];
            const tall = idx === 0;
            return (
              <article
                key={svc.id}
                data-testid={`service-card-${svc.key}`}
                className={`${spans[idx % spans.length]} group relative overflow-hidden bg-[#121217] border border-white/5 hover:border-[#D4AF37]/40 transition-all duration-500`}
              >
                <div className={`relative ${tall ? "h-[420px] md:h-full" : "h-[260px]"} overflow-hidden`}>
                  <img
                    src={svc.image_url}
                    alt={lang === "fr" ? svc.title_fr : svc.title_tr}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-[#0A0A0C]/40 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                    <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-3">
                      0{idx + 1}
                    </div>
                    <h3 className="font-display font-light text-2xl md:text-3xl text-white tracking-tight">
                      {lang === "fr" ? svc.title_fr : svc.title_tr}
                    </h3>
                    <p className="mt-3 text-sm text-white/60 leading-relaxed max-w-md">
                      {lang === "fr" ? svc.description_fr : svc.description_tr}
                    </p>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
